import { useContext } from "react";

import ContrasenaContext from "../context/ContrasenaProvider";

const useContrasena = () => {
    return useContext(ContrasenaContext)
}

export default useContrasena